import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import Icon from '../../_shared/components/Icon';

import { StyledPageBar, StyledButton, PageNumber } from './Styles';

const propTypes = {
  isOmp: PropTypes.bool,
  loadPrevPage: PropTypes.func,
  loadNextPage: PropTypes.func,
  hasNextPage: PropTypes.bool,
  hasPreviousPage: PropTypes.bool,
  pageNumber: PropTypes.number
};

const defaultProps = {
  isOmp: false,
  loadPrevPage: undefined,
  loadNextPage: undefined,
  hasNextPage: false,
  hasPreviousPage: false,
  pageNumber: undefined
};

const Pagination = ({
  loadPrevPage,
  loadNextPage,
  hasNextPage,
  hasPreviousPage,
  pageNumber,
  isOmp
}) => {
  return (
    <StyledPageBar isOmp={isOmp}>
      {hasPreviousPage && (
        <StyledButton variant="prev" onClick={loadPrevPage}>
          <Icon icon="TR5-Prev_chev" />
          <FormattedMessage id="pagination.prev" />
        </StyledButton>
      )}
      <PageNumber>
        {Number(pageNumber) > 1 ? `Page ${pageNumber}` : ``}
      </PageNumber>
      {hasNextPage && (
        <StyledButton variant="next" onClick={loadNextPage}>
          <FormattedMessage id="pagination.next" />
          <Icon icon="TR5-Next_chev" />
        </StyledButton>
      )}
    </StyledPageBar>
  );
};

Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps;
export default Pagination;
